var map = {
	"./build-config-chain": 436,
	"./build-config-chain.js": 436,
	"./config": 426,
	"./config.js": 426,
	"./index": 414,
	"./index.js": 414,
	"./option-manager": 411,
	"./option-manager.js": 411,
	"./parsers": 415,
	"./parsers.js": 415,
	"./removed": 435,
	"./removed.js": 435
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 440;



//////////////////
// WEBPACK FOOTER
// ./~/babel-core/lib/transformation/file/options ^\.\/.*$
// module id = 440
// module chunks = 0